"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "withTheme", {
  enumerable: true,
  get: function get() {
    return _withTheme["default"];
  }
});
Object.defineProperty(exports, "useTheme", {
  enumerable: true,
  get: function get() {
    return _withTheme.useTheme;
  }
});
Object.defineProperty(exports, "ThemeContext", {
  enumerable: true,
  get: function get() {
    return _withTheme.ThemeContext;
  }
});
Object.defineProperty(exports, "withAuth", {
  enumerable: true,
  get: function get() {
    return _withAuth["default"];
  }
});
Object.defineProperty(exports, "connect", {
  enumerable: true,
  get: function get() {
    return _connect["default"];
  }
});
Object.defineProperty(exports, "showLoading", {
  enumerable: true,
  get: function get() {
    return _showLoading["default"];
  }
});
Object.defineProperty(exports, "shareProps", {
  enumerable: true,
  get: function get() {
    return _shareProps["default"];
  }
});
Object.defineProperty(exports, "imgLoader", {
  enumerable: true,
  get: function get() {
    return _imgLoader["default"];
  }
});
exports.Wrappers = void 0;

var _withTheme = _interopRequireWildcard(require("./with-theme"));

var _withAuth = _interopRequireDefault(require("./with-auth"));

var _connect = _interopRequireDefault(require("./connect"));

var _reduxFalcor = _interopRequireDefault(require("./redux-falcor"));

var _withRouter = _interopRequireDefault(require("./with-router"));

var _showLoading = _interopRequireDefault(require("./show-loading"));

var _shareProps = _interopRequireDefault(require("./share-props"));

var _imgLoader = _interopRequireDefault(require("./img-loader"));

var _avlFalcor = _interopRequireDefault(require("./avl-falcor"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Wrappers = {
  "with-theme": _withTheme["default"],
  "with-auth": _withAuth["default"],
  connect: _connect["default"],
  "redux-falcor": _reduxFalcor["default"],
  "with-router": _withRouter["default"],
  "show-loading": _showLoading["default"],
  "share-props": _shareProps["default"],
  "avl-falcor": _avlFalcor["default"]
};
exports.Wrappers = Wrappers;